/** Isolated study pose, no renderer/state mutation. Radians and canonical units.
 * Helper revision 5; parent/native review pending. Angles are bounded animation tuning informed by
 * observed settled overlap, not measured species joint kinematics.
 * Compose T(pivot) * Rz(flap) * Ry(sweep) * T(-pivot), then role bind.
 * Do not add this to the published/default adapter without the separate gate.
 */
const clamp=x=>Math.max(0,Math.min(1,x));
export const BUTTERFLY_FOUR_WING_PROFILE='butterfly-four-wing-study-4';
export const BUTTERFLY_WING_PIVOTS=Object.freeze({
 butterfly_forewing_L:Object.freeze([-.005,0,-.018]),butterfly_forewing_R:Object.freeze([.005,0,-.018]),
 butterfly_hindwing_L:Object.freeze([-.006,0,-.008]),butterfly_hindwing_R:Object.freeze([.006,0,-.008])
});
// Monarch, male common blue, male cabbage white. Closed-wing separation is kept
// positive; the hindwing's lower bind layer is outermost when both fold upward.
const REST=Object.freeze([
 Object.freeze({fore:1.52,hind:1.52,foreSweep:.36,hindSweep:.12,bask:.24}),
 Object.freeze({fore:1.54,hind:1.54,foreSweep:.46,hindSweep:.17,bask:.30}),
 Object.freeze({fore:1.53,hind:1.53,foreSweep:.38,hindSweep:.13,bask:.27})
]);
export function butterflyRolePose(role,pose,variant=0){
 const pivot=BUTTERFLY_WING_PIVOTS[role];if(!pivot)return{pivot:[0,0,0],flap:0,sweep:0};
 const side=role.endsWith('_L')?-1:1,fore=role.includes('forewing'),r=REST[variant]??REST[0],routeFlight=clamp(pose.flight??0),landing=(pose.phase??0)>=.89,opening=clamp(routeFlight/(landing?.45:.03)),flight=opening*opening*(3-2*opening),fold=1-flight;
 // Complete opening early in the existing route easing, before substantial
 // departure. Close earlier over the landing half of the route to clear the
 // supporting flower before descent. The phase switch occurs on the fully
 // open plateau; phase wrap occurs with flight zero. Both are continuous.
 // This C1 blend changes wings only; root/contact clocks stay exact.
 // Reuse the established brief settled opening phrase. Weather closes the
 // wings slightly; no extra clock, random source, route or contact state.
 const weather=clamp(pose.weatherResponse??0),bask=clamp((1.13-((pose.wingAngle??1.13)-weather*.32))/.35),closed=Math.min(1.565,(fore?r.fore:r.hind)-r.bask*bask+weather*.025),air=.35+(pose.flap??0)*.78;
 return{pivot,flap:side*(fold*closed+flight*air),sweep:side*fold*(fore?-r.foreSweep:r.hindSweep)};
}
